var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGadgets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0001 30V34H30.0001V38H10.0001V34H18.0001V30H1.98406C1.72142 29.9979 1.46176 29.9441 1.21991 29.8417C0.978055 29.7392 0.758751 29.5901 0.574518 29.4029C0.390285 29.2157 0.244731 28.9941 0.146166 28.7506C0.0476003 28.5071 -0.00204506 28.2466 6.45149e-05 27.984V2.016C6.45149e-05 0.902 0.910065 0 1.98406 0H38.0161C39.1121 0 40.0001 0.898 40.0001 2.014V27.984C40.0001 29.098 39.0901 30 38.0161 30H22.0001Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGadgets);
export default __webpack_public_path__ + "static/media/gadgets.6f570e178ba495059c0386a1785264f9.svg";
export { ForwardRef as ReactComponent };